import React, { Component } from 'react'
import Nav from '../Nav'
import StarfieldAnimation from 'react-starfield-animation'
const axios = require('axios');

export default class Comic extends Component {

    state = {
        tokens: [],
        walletName : '',
        stargazeAdd : '',
        loading : false,
    }

    async componentDidMount() {
        await this.connectKeplr();

        window.addEventListener("keplr_keystorechange", (async () => {
            await this.connectKeplr();
        }));
    }

    async connectKeplr() {
        if (window.keplr) {
            try {

                let r = await window.keplr.enable('stargaze-1');

                const { name, bech32Address } = await window.keplr.getKey('stargaze-1')

                this.setState({
                    walletName: name,
                    stargazeAdd: bech32Address
                });

                console.log(bech32Address);

                setTimeout(async () =>{
                    await this.loadComics()
                },1000)

            } catch (error) {
                console.log(error);
            }
        }
    }

    async loadComics(){
        try {
            const { stargazeAdd } = this.state;

            this.setState({
                loading : true
            })

            let url = `https://nots-core.herokuapp.com/nft/Comic?account=${stargazeAdd}`

            const { data } = await axios.get(url);

            this.setState({
                loading : false,
                tokens : data.data,
            })

            

        } catch (error) {
            this.setState({
                loading: false
            })
            console.log(error);
            alert('Something went wrong.')
        }
    }

    async test() {
        await new Promise(resolve => setTimeout(resolve, 1900));
    }

    isNOTist(){
        const { tokens} = this.state;

        let fo = tokens.filter(e =>{return e.data != null});

        if(!fo) return false;
       
        console.log(fo.length > 2,fo.length);
        return( fo.length > 2);
        
    }

    renderView(id) {
        const { tokens, loading, stargazeAdd, walletName } = this.state;

        if (tokens.length === 0) {
            return (
                <>
                    <img src={`./images/uni/day_${id}.png`} className='uni-placeholder img-fluid' />
                    <p>Day 00{id} - 000</p>
                </>);
        }

        if (tokens.length > 0 && tokens[id-1].data === null) {
            return (
                <>
                    <img src={`./images/uni/day_${id}.png`} className='uni-placeholder img-fluid' />
                    <p className='no-day'>Day 00{id} - 000</p>
                </>);
        }


        const {data} = tokens[id-1]

        return (
            <a className='' href={data.image} target="_blank">
                <img src={data.image} className='uni-placeholder-active img-fluid' />
                <p>{data.name.replace('NOTs Universe - ','')}</p>
            </a>);

    }


    render() {
        const { tokens,loading,stargazeAdd,walletName } = this.state;
        
        return (
            <div className='not-uni'>

                <StarfieldAnimation
                    style={{
                        position: 'absolute',
                        width: '100%',
                        height: '100%'
                    }}
                    numParticles={500}
                />

                <div className="container" style={{
                    zIndex: 1000
                }}>

                    <div className="row justify-content-center">
                        <div className="col-lg-12 uni-banner">
                            <div className="text-center">
                                <h6 className="text-gradiant fw-bold"></h6>
                                <br />
                                <h1 className="fw-bold">NOTs Universe</h1>
                                <h6 className='text-white'>
                                    NOTs Universe is the first comic series launched on Cosmos telling the story of brave NOTs forming an IBC Alliance in their fight against General Fiat & FUD Zombies
                                </h6>
                                <button onClick={async () =>{
                                    await this.connectKeplr();
                                }}
                                className={stargazeAdd === '' ? 'btn btn-connect' : 'btn btn-connected'}>
                                    {stargazeAdd === '' ? 'Connect wallet' : `${walletName} - ${stargazeAdd.substring(0,8)}...${stargazeAdd.substring(stargazeAdd.length - 4,stargazeAdd.length)}`}
                                </button>
                                {
                                    loading ? <h6 className='text-white' style={{marginTop : 10}}>Loading . . . </h6> : null
                                }
                            </div>
                        </div>

                        {
                            tokens.length > 0 && this.isNOTist() ? 
                            <>
                                <div className='col-lg-12 happy-banner text-center'>
                                    <p className='happy-banner-p'>NOTics, You are eligible for a bonus comic airdrop by owning at least 3 of 10 strips</p>
                                </div>
                            </> : null
                        }

                        <div className='spacer' />

                        <div class="row">
                            <div class="col">
                                {
                                    this.renderView(1)
                                }
                            </div>
                            <div class="col">
                                {
                                    this.renderView(2)
                                }
                            </div>
                            <div class="col">
                                {
                                    this.renderView(3)
                                }
                            </div>
                            <div class="col">
                                {
                                    this.renderView(4)
                                }
                            </div>
                            <div class="col">
                                {
                                    this.renderView(5)
                                }
                            </div>
                            
                        </div>

                        <div class="row">
                            <div class="col">
                                {
                                    this.renderView(6)
                                }
                            </div>
                            <div class="col">
                                {
                                    this.renderView(7)
                                }
                            </div>
                            <div class="col">
                                {
                                    this.renderView(8)
                                }
                            </div>
                            <div class="col">
                                {
                                    this.renderView(9)
                                }
                            </div>
                            <div class="col">
                                {
                                    this.renderView(10)
                                }
                            </div>
                        </div>

                        <div className="col-lg-12 uni-footer">
                            <div className="text-center">
                                <h6 className='text-white pw'>
                                    <a href='https://twitter.com/wild_developer_' target={'_blank'}>Powered by Wild Tools</a>
                                </h6>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        )
    }
}
